import api from './api';

export default {
  getBills(page, pageSize, orderby, filters) {
    return new Promise((resolve, reject) => {
      api
        .get('bill', {
          params: {
            includes: 'enquiry',
            paginate: pageSize,
            page,
            orderby,
            filters
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getPaginatedEnquiries(page, pageSize, orderby, terms, ranges, dates, fields, filters, search) {
    fields = { ...fields };

    let params = {
      paginate: pageSize,
      page,
      orderby,
      terms,
      ranges,
      dates,
      fields,
      filters,
      search
    };

    return new Promise((resolve, reject) => {
      api
        .get('bill/search', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  updateBill(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`bill/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  addBill(bill) {
    return new Promise((resolve, reject) => {
      api
        .post(`bill`, bill)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  addBillComment(id, comment) {
    return new Promise((resolve, reject) => {
      api
        .post('activity', {
          subject_id: id,
          subject_type: 'bill',
          comment,
          privacy: 'internal'
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  downloadBillsCsv(params) {
    params.paginate = 5000;
    return api.get('bills/export', { params, responseType: 'blob' });
  }
};
